export enum FormDefinitionSpecialAction {
    AddRowAbove = "AddRowAbove",
    AddRowBelow = "AddRowBelow"
};
